<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
  >
    <template slot="title">
      <h1><i class="el-icon-success"></i>&nbsp;Film submitted</h1>
    </template>
    <p>You will receive an email from our submission team shortly, and stay tuned for our feedback in your inbox.</p>

    <SurveyForm @update="getSurveyFormUpdate" />

    <span slot="footer">
      <el-button
        @click="handleDone"
      >Done</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SurveyForm from './PostSubmissionDialog/SurveyForm';
import { postSurvey } from './PostSubmissionDialog/surveyModelHelper';

export default {
  components: {
    SurveyForm,
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      surveyData: null,
    };
  },

  methods: {
    getSurveyFormUpdate(surveyPayload) {
      this.surveyData = surveyPayload;
    },

    handleDone() {
      const userData = {
        userId: this.$store.state.account.blob.id,
        submissionId: this.$route.params.videoId,
        country: this.$store.state.account.blob.film_maker_details.country,
      };

      this.$router.push('/');

      // Fire and forget
      setTimeout(() => postSurvey(this.surveyData, userData));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Submission/Shared/PostSubmissionDialog.vue